.header {
    padding-bottom: 80px;
}

form > div {
    margin: 10px 0px;
}

.buttonContainer {
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
}
